import { Pipe, PipeTransform } from '@angular/core';
import { Enum } from '@nts/std/types';
import { MessageResourceManager } from '../../resources/message-resource-manager';

@Pipe({
    name: 'NTSEnum',
    standalone: true
})
export class NTSEnumPipe implements PipeTransform {
    transform(value: number | string, enumToUse: any, enumName: string): string {
        if (value == null) return '';
        return Enum.getFormattedValue(value, enumToUse, enumName, MessageResourceManager.Current);
    }
}